const url = window.location.href;
const arr = url.split('/');
const path = `${arr[0]}//${arr[2]}/api`;
const protocols = {
  http: arr[0],
  websocket: arr[0].replace('http', 'ws'),
};

export const API_URL = process.env.NODE_ENV === 'production' ? path : '/api';
export const FULL_API_URL = `${protocols.http}//${window.location.host}`;
export const WS_API_URL = `${protocols.websocket}//${process.env.REACT_APP_API_HOST ||
  window.location.host}/api/notificationscentre-ws`;
